import { FormattedMessage } from "react-intl";

import { Escalation } from "../../../interfaces"
import { deslugify } from "../../../utils/slugify";

type EscalationAlertProps = {
  escalation: Escalation;
  solveEscalations: Function;
  scrollToEscalation?: Function;
  type?: "conversation" | "playground";
}

export default function EscalationAlert({
  escalation,
  solveEscalations,
  scrollToEscalation,
  type = "conversation"
}: EscalationAlertProps) {
  const isPlayground = type === "playground";
  return (
    <div className="chat-interface-header text-bg-warning-subtle">
      <div
        className="navigation flex align-items-center justify-content-between"
        style={isPlayground ? { padding: "0.5rem 1rem" } : {}}
      >
        <div className="escalation-info color-dark">
          <div className="color-step-900 fs-2 fw-semibold-1">
            <span style={{ textTransform: "capitalize" }}>
              <FormattedMessage id="esc.escalation" />:{" "}
              {escalation?.type && deslugify(escalation?.type, true)}
              {" "}
            </span>
            {!["manual"].includes(
              escalation?.type
            ) && scrollToEscalation ? (
              <a
                className="color-visito-2 pointer"
                onClick={() => scrollToEscalation(escalation?.message)}
              >
                <FormattedMessage id="esc.clickToView" />
              </a>
            ) : null}
          </div>
          <div className="fs-1 color-step-900 m0">
            {escalation?.details}
          </div>
        </div>
        <div className="escalation-resolution">
          <button
            className={`btn btn-visito-primary ${isPlayground ? "btn-xs" : "btn-sm"}`}
            onClick={() =>
              solveEscalations()
            }
          >
            <FormattedMessage id="esc.solve" />
          </button>
        </div>
      </div>
    </div>
  )
}
